<template>
  <div class="invoice-album">
        <div class="invoice-thumb-box">
            <!--发票大图展示-->
            <div class="invoice-thumb" v-if="picImgs.length>0">
                <div class="invoice-thumb-item-box">
                    <PreviewPDF :pdfUrl="ImgPreUrl+downloadUrl.url" :scale="1.24" v-if="downloadUrl.type==='pdf'" />
                    <img v-else :src="ImgPreUrl+downloadUrl.url" alt="" class="invoice-thumb-item" />
                </div>
                <div class="invoice-thumb-download">
                    <el-button size="small" icon="el-icon-zoom-in"  @click="handleLoad(downloadUrl.url)">放大文件</el-button>
                    <el-button size="small" icon="el-icon-download" type="primary" @click="downloadImg(downloadUrl)">下载文件</el-button>
                </div>
            </div>
            <!--缩略小图展示-->
            <div class="invoice-thumb-list">
                <div class="invoice-thumb-list-title">发票张数：{{ picImgs.length }}</div>
                <ul class="invoice-thumb-list-content">
                    <li v-for="(item,index) in picImgs" :key="index" @click="PreUrl(item) ;picindex=index" :class="{'active':picindex===index}">
                        <!-- <PreviewPDF :pdfUrl="ImgPreUrl+item.url" :scale="0.28" v-if="item.type==='pdf'"  /> -->
                        <img src="/images/public/invoice.jpg" alt="" class="invoice-thumb-item">  
                    </li>
                </ul>
            </div>
        </div>
        <!--放大图片-->

  </div>
</template>

<script>
import PreviewPDF from '@/components/Tool/PreviewPDF';
import { mapState,mapActions} from 'vuex'
export default {
  name: 'InvoiceAlbum',
  components: {PreviewPDF},
  props: {
    invoiceItem: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
        picindex:0,                //当前展示的图片索引
        picImgs:[],                //发票图片数组
        downloadUrl:{},            //当前显示图片url
    };
  },
  computed: {},
  watch: {
    invoiceItem: {
        handler(newVal, oldVal) {
        if (newVal.pdfUrl) {
            let picImgs=newVal.pdfUrl.split(',').map(item=>{
                return{
                    url:item,
                    type:'',
                };
            })
            this.picindex=0;
            this.PreUrl(picImgs[0]);
            this.picImgs=picImgs;
        }
      },
      deep: true,
      immediate:true // 立即执行一次
    }
  },
  created() {},
  mounted() {},
  methods: {
     ...mapActions(['POST_GetQiNiuFileExt']),
        //获取预览图片的url
        async PreUrl(item){
            let localItem=JSON.parse(localStorage.getItem('invoiceAlbum'))||[];
            //url判断是否有缓存
            let isCache=localItem.find(local=>local.url===item.url);
            if(!isCache){
                const format = await this.POST_GetQiNiuFileExt({key:item.url});
                item.type=format;
                localItem.push(item);
                this.downloadUrl=item;
                //存储本地缓存对象格式
                localStorage.setItem('invoiceAlbum', JSON.stringify(localItem));
            }else{
                console.log(isCache);
                this.downloadUrl=isCache;
            }
        },
        /*下载图片-文件*/
        downloadImg(imgItem){
            if(imgItem.type.indexOf('image')!==-1){
            }else{
                this.$_Array.downloadPdfByUrl(imgItem.url, `${this.invoiceItem.title}发票.${imgItem.type}`);
            }
        },
              //文件预览
        handleLoad(base64Str){
            window.open(this.$GFUN.formatImgSrc(base64Str));
            return
        },
  }
};
</script>

<style lang="scss" scoped>
.invoice-thumb-item-box{
    height: 530px;
}
.invoice-album{
    background-color: #f5f7fa;
    overflow: hidden;
    width: 980px;
    margin: 0 auto;
    padding: 10px;
    border-radius: 6px;
}
.invoice-thumb-box{
    display: flex;
    justify-content:space-between;
}
.invoice-thumb{
    width: 76%;
    background-color: #fff;
    padding: 10px;
    border-radius: 6px;
    overflow: hidden;
}
.invoice-thumb-list{

    background-color: #fff;
    padding: 10px;
    border-radius: 6px;
    overflow: hidden;
}
.invoice-thumb-list li{
    background-color: #fafbfc;
    padding: 6px;
    width: 170px;
    margin: 0 auto;
    margin-bottom: 10px;
    border-radius: 6px;
    cursor: pointer;
}
.invoice-thumb-list-title{
    text-align: left;
    font-weight: bold;
    margin-bottom: 10px;
    margin-left: 6px;
}
.invoice-thumb-list .active{
    background-color: var( --smtc-color-primary);
}
.invoice-thumb-item{
    width: 100%;
    object-fit: cover;
}
.invoice-thumb-list-content{
    height: 560px;
    overflow-y: auto;
}
</style>
